import React, { useEffect, useState } from "react";
import "./Principal.css";
import { database } from "./firebaseConfig";
import { get, ref } from "firebase/database";
import { useNavigate } from "react-router-dom";
import ImgCard from "./Components/ImgCard";
import CategoryBar from "./Components/CategoryBar";
import CookieBanner2 from "./Components/Cookie/CookieBanner2";
import ShareButton from "./Components/ShareButton";

const Principal = () => {
  // Curiosità principale del giorno
  const [infoDelGiorno, setInfoDelGiorno] = useState("");

  // Array di oggetti sezione recuperati da Firebase
  const [sezioni, setSezioni] = useState([]);

  // Messaggio temporaneo in caso di errore
  const [messaggio, setMessaggio] = useState("");

  // Per cambiare pagina programmaticamente
  const navigate = useNavigate();

  //Stato per gestire il menù mobile o desktop
  const [menuOpen, setMenuOpen] = useState(false);

  // --- RECUPERO SEZIONI DAL DATABASE ---
  useEffect(() => {
    const sezioniRef = ref(database, "sezioni");
    get(sezioniRef).then((snapshot) => {
      if (snapshot.exists()) {
        setSezioni(snapshot.val());
      } else {
        console.log("Nessuna sezione trovata.");
      }
    });
  }, []);

  // --- RECUPERO INFO DEL GIORNO ---
  useEffect(() => {
    const dataRef = ref(database, "infoDelGiorno");
    get(dataRef).then((snapshot) => {
      if (snapshot.exists()) {
        setInfoDelGiorno(snapshot.val());
      } else {
        console.log("Nessun dato trovato per info del giorno.");
      }
    });
  }, []);

  // --- GESTIONE CLICK SU SEZIONE ---
  const handleSezioneClick = (sezione) => {
    if (!sezione.articoli || sezione.articoli.length === 0) {
      setMessaggio(`Nessun articolo disponibile per ${sezione.titolo}`);
      setTimeout(() => setMessaggio(""), 3000);
    } else {
      navigate(`/sezione/${sezione.slug}`);
    }
  };

  const message = ()=>{
    alert("Sezione disponibile a breve");
  }

  // --- RENDER PRINCIPALE ---
  return (
    <div>
      <div className="containerBar">
          <div className="containerNavBar">
            <nav className="navbar">
              <div className="logo">
                10<span>curiosita</span>.it
              </div>
              {/*Icona menù per dispositivi mobili */}
              <div className="menu-icon" onClick={()=> setMenuOpen(!menuOpen)}>
                ☰
              </div>
              {/* Menù di navigazione */}
              <ul className={`menu ${menuOpen ? "open" : ""}`}>
                <li><a href="/">Home</a></li>
                <li><a onClick={message} style={{cursor: "pointer"}}>Articoli</a></li>
                <li><a onClick={message} style={{cursor: "pointer"}}>Curiosità del giorno</a></li>
                <li><a onClick={message} style={{cursor: "pointer"}}>Contatti</a></li>
              </ul>
            </nav>
            </div>
            <div className="categoryBarWrapper">
              <CategoryBar sezioni={sezioni} onClick={handleSezioneClick} />
            </div>
        </div>
      <div className="principal-container">
        <CookieBanner2 />
        

        <section className="info-del-giorno">
          <h2 className="CuriositàDelGiorno">CURIOSITÀ DEL GIORNO</h2>
          <p>{infoDelGiorno}</p>
          <ShareButton/>
        </section>

        <section>
          {messaggio && <p className="avviso">{messaggio}</p>}
          <div className="sezioni-container">
            {sezioni.map((sezione) => (
              <ImgCard
                key={sezione.id}
                sezione={sezione}
                titolo={sezione.titolo}
                descrizione={sezione.descrizione}
                slug={sezione.slug}
                pathImmagine={sezione.immaginePath}
                onClick={handleSezioneClick}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Principal;
